const theme = {
    // Smartphones Mobiles (Portrait)
    mqMobile: `@media (min-width: 320px) and (max-width: 480px)`,
    // Smartphones Mobiles (Landscape)
    mqMobileHorz: `@media (min-width: 481px) and (max-width: 767px)`,
    // Tablets, Ipads (Portrait)
    mqTablets: `@media all (min-width: 768px) and (max-width: 1024px)`,
    // Tablets, Ipads (Landscape)
    mqTabletsHorz: `@media all (min-width: 768px) and (max-width: 1024px) and (orientation: landscape)`,
    // Desktops
    mqSmallDesktops: `@media (min-width: 1025px)`,
    mqMediumDesktops: `@media (min-width: 1281px)`,
    mqLargeDesktops: `@media (min-width: 1600px)`,
    mqXLargeDesktops: `@media (min-width: 1920px)`,

    // Main colors
    $color_1: `#E3F4FF`, // left column active bg
    $color_2: `#009A3F`, // active elements, checkboxes, buttons
    $color_3: `#3EE2EF`,
    $color_4: `#2999BF`,
    $color_5: `#424C71`, // top header
    $color_6: `#70BF44`, // active buttons
    $color_7: `#51A517`,
    $color_8: `#F4F4F4`, // left column lighter bg
    $color_9: `#EFEFEF`, // table header bg
    $color_10: `#3F3F3F`, // dark grey
    $color_11: `#E8E8E8`, // left column darker bg
    $color_12: `#3C3C3C`, // carousel bg
    $color_13: `#F97447`,
    $color_14: `#F9C023`,
    $color_15: `#F82B00`,
    $color_16: `#E1E1E1`,
    
    // Additional colors
    $color_17: `#F75703`, // orange
    $color_18: `#BC4405`, // dark orange
    $color_19: `#F8A072`, // light orange
    $color_20: `#404040`, // dark gray
    $color_21: `#222222`, // almost black
    $color_22: `#2D2D2D`, // dark gray
    $color_23: `#333333`, // dark gray
    $color_24: `#191919`, // almost black
    $color_25: `#fff`, // white
    $color_26: `#A1A1A1`, // light gray
    $color_27: `#1C1C1C`, // almost black
    $color_28: `#00A651`, // green
    $color_29: `#078143`, // dark green
    $color_30: `#004D26`, // dark green
    $color_31: `#007639`, // dark green
    $color_32: `#85C9A6`, // light green
    $color_33: `#CACACA`, // light gray
    $color_34: `#242c2f`, // dark blueish gray
    $color_35: `#282828`, // dark gray
    $color_36: `#A3A3A3`, // gray
    $color_37: `#F3F3F3`, // almost white
    $color_38: `#EAEAEA`, // almost white
    $color_39: `#a8a8a8`, // gray
    $color_40: `#646464`, // dark gray
    $color_41: `#787878`, // gray
    $color_42: `#2d9ef5`, // blue
    $color_43: `#2d9ef5`, // blue duplicate?
    $color_44: `#FFF200`, // yellow
    $color_45: `#C1C1C1`, // gray
    $color_46: `#009A3F`, // green 
    $color_47: `#929292`, // gray
    $color_48: `#000`, // black
    $color_49: `#FEDA31`, // gold
    $color_50:'#FFFF00', // yellow duplicate?
    $color_51:'#01121C', // blueish black
    $color_52:'#FAE100', // gold
    $color_53:'#019A44', // green
    $color_54:'#111111', // black
    $color_55: '#ffdb01', // gold
    $color_56: '#da281c', // red
    $color_57: '#44a30a', // green
    $color_58: '#DEDEDE', // light gray
    $color_59: '#00AF28', // green
    $color_60: '#9D9D9D', // gray
    $color_61: '#707070', // dark gray
    $color_62: '#C82419', // red
    $color_63: '#C6C6C6', // gray
    $fontFamily: `'Roboto', sans-serif`,
};

// top menu
theme['$topMenuBackgroundColor'] = theme['$color_27'];
theme['$topMenuLogoBackgroundColor'] = theme['$color_27'];

theme['$topMenuTopBarColor'] = theme['$color_5'];
theme['$topMenuTopBarBgColor'] = theme['$color_2'];

theme['$topMenuSubMenuBackgroundColor'] = theme['$color_12'];
theme['$topMenuSubMenuBorderTopColor'] = theme['$color_2'];
theme['$topMenuSubMenuBorderColor'] = theme['$color_49'];
theme['$topMenuLanguageFieldColor'] = theme['$color_25'];
theme['$topMenuRegisterBgcColor'] = theme['$color_50']
theme['$topMenuRegisterTextColor']= theme['$color_51']

theme['$topMenuListItemActiveColor'] = theme['$color_49'];
theme['$topMenuActiveLinkColor'] = theme['$color_49'];
theme['$topMenuLinkColor'] = theme['$color_45'];
theme['$topMenuUnloggedBtnColor'] = theme['$color_25'];
theme['$topMenuLoggedOutBtnColor'] = theme['$color_25'];
theme['$topMenuLoggedOutBtnBgColor'] = theme['$color_5'];
theme['$topMenuLoggedUserLoginColor'] = theme['$color_51'];
theme['$topMenuLoggedUserLoginBgColor'] = theme['$color_50']
theme['$topMenuLoggedUserQuickMenuWrapper'] = theme['$color_52']
// categories
theme['$categoriesDropdownItemBgColor'] = theme['$color_12'];
theme['$categoriesDropdownItemColor'] = theme['$color_25'];
theme['$categoriesDropdownItemActiveColor'] = theme['$color_49'];
theme['$categoriesDropdownItemBgColorHover'] = theme['$color_12'];
theme['$categoriesDropdownItemBorderBottom'] = theme['$color_48'];
theme['$categoriesActiveEventsCountColor'] = theme['$color_25'];

theme['$categoriesDropdownItemLvl2BgColor'] = theme['$color_21'];
theme['$categoriesDropdownItemLvl2ActiveBgColor'] = theme['$color_47'];
theme['$categoriesDropdownItemLvl2ActiveTitleColor'] = theme['$color_2'];
theme['$categoriesDropdownItemLvl2ArrowColor'] = theme['$color_25'];
theme['$categoriesDropdownItemLvl2ActiveArrowColor'] = theme['$color_49'];
theme['$categoriesDropdownItemLvl3BgColor'] = theme['$color_27'];
theme['$categoriesEventsCount'] = theme['$color_25'];
theme['$categoriesLvl3CheckboxBgColor'] = theme['$color_27'];
theme['$categoriesLvl3CheckboxActiveBgColor'] = theme['$color_49'];
theme['$categoriesLvl3CheckboxBorderColor'] = theme['$color_25'];
theme['$categoriesLvl3CheckboxActiveBorderColor'] = theme['$color_49'];

theme['$categoriesMarkerColor'] = theme['$color_2'];

// instant win games

theme['$iwgMainColor'] = theme['$color_2'];
theme['$iwgSecondaryColor'] = theme['$color_50'];
theme['$iwgLightTextColor'] = theme['$color_25'];
theme['$iwgDarkTextColor'] = theme['$color_48'];
theme['$iwgRedTextColor'] = theme['$color_56'];
theme['$iwgGreenTextColor'] = theme['$color_57'];
theme['$iwgBalanceBgColor'] = theme['$color_27'];
theme['$iwgPaymentsContainerBgColor'] = theme['$color_38'];
theme['$iwgPaymentSwitchBgColor'] = theme['$color_63'];
theme['$iwgPaymentSwitchTextColor'] = theme['$color_60'];
theme['$iwgPaymentSwitchBgColorActive'] = theme['$color_54'];
theme['$iwgPaymentBgColor'] = theme['$color_37'];

// login form
theme['$loginFormSubmitBtnColor'] = theme['$color_25'];
theme['$loginFormSubmitBtnBgColor'] = theme['$color_2'];

// register form
theme['$registerFormSubmitBtnColor'] = theme['$color_25'];
theme['$registerFormSubmitBtnBgColor'] = theme['$color_2'];

// account
theme['$accountTopLeftSideBgColor'] = theme['$color_5'];
theme['$accountBgColor'] = theme['$color_53']
theme['$accountPrimaryColor'] = theme['$color_52']

// gambling controls
theme['$gamblingControlsPrimaryColor'] = theme['$color_2'];

// instant win games list
theme['$iwgPageBackgroundColor'] = theme['$color_35'];
theme['$iwgCardBackgroundColor'] = theme['$color_48'];
theme['$iwgCardTextColor'] = theme['$color_25'];
theme['$iwgImageBackgroundColor'] = theme['$color_48'];
theme['$iwgImageFilterBackgroundColor'] = theme['$color_54']; 
theme['$iwgSessionStatusActiveTextColor'] = theme['$color_55'];
theme['$iwgSessionStatusActiveDotColor'] = theme['$color_55'];
theme['$iwgSessionStatusActiveSessionUserColor'] = theme['$color_57'];
theme['$iwgSessionStatusInActiveTextColor'] = theme['$color_56'];
theme['$iwgSessionStatusInActiveDotColor'] = theme['$color_56'];
theme['$iwgGamesListEmptyColor'] = theme['$color_25'];

// instant win game page
theme['$iwgGameMainWrapper'] = theme['$color_35'];
theme['$iwgGameNameColor'] = theme['$color_25'];

// Session Extension - prolong session
theme['$sessionExtensionWrapperBackgroundColor'] = theme['$color_58'];
theme['$sessionExtensionWrapperTextColor'] = theme['$color_54'];
theme['$sessionExtensionTopRowBackgroundColor'] = theme['$color_52'];
theme['$sessionExtensionTopRowDistinctiveTextColor'] = theme['$color_59'];
theme['$sessionExtensionMainMessageTextColor'] = theme['$color_60'];

theme['$sessionExtensionBalanceLabelColorText'] = theme['$color_54'];
theme['$sessionExtensionBalanceBackgroundColor'] = theme['$color_54'];
theme['$sessionExtensionBalanceTextColor'] = theme['$color_25'];

theme['$sessionExtensionButtonsContainerBorderColor'] = theme['$color_61'];
theme['$sessionExtensionButtonTextColor'] = theme['$color_25'];
theme['$sessionContinueButtonBackgroundColor'] = theme['$color_62'];
theme['$sessionExtensionLeaveButtonBackgroundColor'] = theme['$color_54'];
theme['$sessionExtensionReLoginButtonBackgroundColor'] = theme['$color_59'];
theme['$sessionExtensionConfirmButtonBackgroundColor'] = theme['$color_59'];

theme['$sessionExtensionErrorTextColor'] = theme['$color_62'];

theme['$sessionExtensionInputBackgroundColor'] = theme['$color_25'];
theme['$sessionExtensionInputTextColor'] = theme['$color_54'];
theme['$sessionExtensionInputBorderColor'] = theme['$color_63'];

theme['$sessionExtensionCounterTextColor'] = theme['$color_54'];

export default theme;